(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
// STATİK YORUMLAR - Tüm Cihazlarda Görünür
// YORUMLARI BURAYA EKLEYİN:
const staticReviews = [
    {
        id: 1,
        customerName: 'Seda S.',
        rating: 5,
        text: 'Normalde şal sürekli kaydığı için gün içinde birkaç kez düzeltmek zorunda kalıyordum. Bu boneli ve mıknatıslı eşarp gerçekten çok rahat. Sabah taktım, akşama kadar aynı şekilde kaldı. Kadınlar için büyük kolaylık.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/1.jpg?v=1768474551',
        date: '2025-12-20',
        verified: true
    },
    {
        id: 2,
        customerName: 'Rabia A.',
        rating: 5,
        text: 'İlk kez mıknatıslı şal kullandım ve çok sevdim. Bone ile birlikte olması ayrı bir konfor sağlıyor. Hem şık duruyor hem de gün boyu kaymıyor, tam aradığım şeymiş.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/5.webp?v=1768474567',
        date: '2025-12-19',
        verified: true
    },
    {
        id: 3,
        customerName: 'Tuğçe Ç.',
        rating: 5,
        text: 'Şal ve eşarp konusunda seçiciyim ama bu ürün beklentimin üstünde çıktı. Kumaşı yumuşak, bone kısmı sıkmıyor. Günlük kullanımda gerçekten çok rahat.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/9.jpg?v=1768474567',
        date: '2025-12-18',
        verified: true
    },
    {
        id: 4,
        customerName: 'Melike D.',
        rating: 5,
        text: 'Sabah işe giderken hızlıca takıp çıkıyorum, gün içinde hiç düzeltme ihtiyacı duymuyorum. Kadınlar için pratik ve şık bir şal olmuş, çok memnunum.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/3.webp?v=1768474567',
        date: '2025-12-17',
        verified: false
    },
    {
        id: 5,
        customerName: 'Canan F.',
        rating: 5,
        text: 'Mükemmel kalite! Arkadaşlarıma da önerdim. Çok memnun kaldım ve tekrar sipariş verdim hemen.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/2.webp?v=1768474567',
        date: '2025-12-16',
        verified: true
    },
    {
        id: 6,
        customerName: 'Esra Z.',
        rating: 5,
        text: 'Bone ve şal uyumu çok güzel. Mıknatısı sayesinde eşarp sabit duruyor, özellikle dışarıda rüzgârda bile bozulmuyor. Artık başka şal kullanmam sanırım.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/8.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 7,
        customerName: 'Zeynep T.',
        rating: 5,
        text: 'Uzun zamandır kaymayan bir şal arıyordum, sonunda buldum. Hem rahat hem de çok zarif duruyor. Günlük hayatta gerçekten fark yaratıyor.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/4.png?v=1768750513',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 8,
        customerName: 'Burcu Y.',
        rating: 5,
        text: 'İlk başta tereddüt etmiştim ama kullanınca ne kadar pratik olduğunu anladım. Bone kısmı başımı ağrıtmıyor, eşarp gün boyu sabit kalıyor. Çok başarılı.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/10.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 9,
        customerName: 'Aslı K.',
        rating: 5,
        text: 'Kadın şal modelleri arasında en rahat kullandığım bu oldu. Boneli yapısı sayesinde kayma sorunu hiç yaşamadım, mıknatıslı eşarp kısmı da çok kullanışlı.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/7.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 10,
        customerName: 'Hatice R.',
        rating: 5,
        text: 'Şıklık ve rahatlık bir arada. Sabah taktığım şal gün boyu aynı şekilde duruyor. Bone ve mıknatıs detayı gerçekten büyük fark yaratmış.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/11.webp?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 11,
        customerName: 'Cansu F.',
        rating: 5,
        text: 'Günlük kullanım için harika bir eşarp. Kumaşı hafif, bone kısmı sıkmıyor. Kadınlar için düşünülmüş pratik bir şal olduğunu hissediyorsunuz.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/12.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 12,
        customerName: 'Pelin U.',
        rating: 5,
        text: 'Uzun süre dışarıda kaldığım günlerde bile şalımı düzeltme ihtiyacı duymuyorum. Mıknatıslı ve boneli olması çok büyük rahatlık.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/14.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 13,
        customerName: 'Şeyma H.',
        rating: 5,
        text: 'Hem sade hem de çok şık duruyor. Kadın şal ve eşarp modelleri içinde en memnun kaldığım ürünlerden biri oldu.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/15.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 14,
        customerName: 'Gizem B.',
        rating: 5,
        text: 'Bone ve şal bir arada olunca kullanım çok kolaylaşıyor. Sabah acelem olduğunda bile hızlıca takıp çıkabiliyorum, gün boyu kaymıyor.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/13.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 15,
        customerName: 'İrem G.',
        rating: 5,
        text: 'Kumaşı çok yumuşak ve hafif. Eşarp başımda ağırlık yapmıyor, mıknatısı sayesinde sabit duruyor. Gerçekten çok rahat bir şal.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/16.jpg?v=1768474568',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 16,
        customerName: 'Nursena A.',
        rating: 5,
        text: 'İlk siparişimdi ama kesinlikle son olmayacak. Kadınlar için hem konforlu hem de şık bir şal tasarlanmış, çok beğendim.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/6.jpg?v=1768474567',
        date: '2025-12-15',
        verified: true
    },
        {
        id: 17,
        customerName: 'Merve G.',
        rating: 5,
        text: 'Uzun süredir böyle kullanışlı bir eşarp arıyordum. Bone kısmı başıma tam oturuyor, şal gün boyu formunu koruyor.',
        image: 'https://cdn.shopify.com/s/files/1/0778/7416/8049/files/17.jpg?v=1768474568',
        date: '2025-12-15',
        verified: true
    }
];

class StaticReviewDisplay {
    constructor() {
        this.reviews = staticReviews;
        this.reviewsPerPage = 6;
        this.currentPage = 1;
        this.init();
    }

    init() {
        this.renderReviews();
        this.updateTotalCount();
        this.setupLoadMore();
    }

    createReviewCard(review) {
        const card = document.createElement('div');
        card.className = 'review-card';
        card.setAttribute('data-review-id', review.id);

        const stars = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
        const verifiedBadge = review.verified ? `
            <span class="verified-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                Onaylı
            </span>
        ` : '';

        card.innerHTML = `
            ${review.image ? `
                <div class="review-image">
                    <img src="${review.image}" alt="Ürün" onerror="this.src='https://via.placeholder.com/400x400?text=Resim+Yüklenemedi'">
                </div>
            ` : ''}
            <div class="review-header">
                <div class="customer-info">
                    <span class="customer-name">${this.escapeHtml(review.customerName)}</span>
                    ${verifiedBadge}
                </div>
                <div class="stars">
                    ${stars.split('').map(star => `<span class="star ${star === '★' ? 'filled' : ''}">${star}</span>`).join('')}
                </div>
            </div>
            <p class="review-text">${this.escapeHtml(review.text)}</p>
            <div class="review-footer">
                <span class="review-date">${this.formatDate(review.date)}</span>
                <button class="helpful-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3"/>
                    </svg>
                    Faydalı
                </button>
            </div>
        `;

        return card;
    }

    renderReviews() {
        const container = document.getElementById('reviews-container');
        const reviewsToShow = this.reviews.slice(0, this.currentPage * this.reviewsPerPage);

        container.innerHTML = '';
        
        if (reviewsToShow.length === 0) {
            container.innerHTML = `
                <div class="empty-state">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/>
                    </svg>
                    <h3>Henüz yorum yok</h3>
                    <p>İlk yorumu eklemek için section dosyasını düzenleyin.</p>
                </div>
            `;
            return;
        }

        reviewsToShow.forEach(review => {
            container.appendChild(this.createReviewCard(review));
        });

        const loadMoreBtn = document.getElementById('load-more-btn');
        if (loadMoreBtn) {
            if (reviewsToShow.length >= this.reviews.length) {
                loadMoreBtn.style.display = 'none';
            } else {
                loadMoreBtn.style.display = 'inline-block';
            }
        }
    }

    setupLoadMore() {
        const loadMoreBtn = document.getElementById('load-more-btn');
        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', () => {
                this.currentPage++;
                this.renderReviews();
            });
        }
    }

    updateTotalCount() {
        const totalElement = document.getElementById('total-reviews');
        if (totalElement) {
            totalElement.textContent = this.reviews.length;
        }
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('tr-TR', options);
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new StaticReviewDisplay();
    console.log('✅ Statik yorumlar yüklendi. Toplam:', staticReviews.length);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
